import React from "react";
import Breadcrumb from "../components/Breadcrumb";

export default function CloudSolutions() {
  return (
    <>
      <Breadcrumb title="Cloud Solutions" />

      <div className="page-service-single">
        <div className="container">
          {/* Main Content */}
          <div className="row">
            <div className="col-lg-12">
              <div className="service-single-content">
                {/* Featured Image */}
                <div className="service-featured-image">
                  <figure className="image-anime reveal">
                    <img
                      src="./assets/images/cloud.png"
                      alt="Cloud Solutions"
                      loading="lazy"
                    />
                  </figure>
                </div>

                {/* Entry Content */}
                <div className="service-entry">
                  <p className="wow fadeInUp" data-wow-delay="0.25s">
                    We help organizations migrate, deploy, and manage cloud
                    infrastructure securely and efficiently. Our cloud solutions
                    are designed for scalability, reliability, and regulatory
                    compliance.
                  </p>

                  <h4 className="mb-2">What we do</h4>
                  <ul>
                    <li>Cloud migration and deployment services</li>
                    <li>Infrastructure monitoring and management</li>
                    <li>Cybersecurity protection and compliance</li>
                    <li>Backup, disaster recovery, and continuity planning</li>
                  </ul>

                  <h4 className="mb-2 mt-2">Value we create</h4>
                  <ul>
                    <li>Scalable and cost-efficient infrastructure</li>
                    <li>Improved security and system resilience</li>
                    <li>Future-ready cloud environments</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Service Blocks */}
          <div className="row">
            <ServiceBlock
              title="Cloud Strategy & Assessment"
              items={[
                "Cloud readiness assessment",
                "Application & infrastructure audit",
                "Migration roadmap creation",
                "Cost forecasting & optimization",
              ]}
            />

            <ServiceBlock
              title="Cloud Setup & Deployment"
              items={[
                "AWS, Azure & GCP setup",
                "Server & VM provisioning",
                "Database & storage setup",
                "Cloud networking & firewalls",
              ]}
            />

            <ServiceBlock
              title="Migration & Optimization"
              items={[
                "Application & database migration",
                "Email & file server migration",
                "Zero-downtime migration",
                "Auto-scaling & load balancing",
              ]}
            />

            <ServiceBlock
              title="Monitoring & Operations"
              items={[
                "24/7 server & network monitoring",
                "APM & log monitoring",
                "Incident alerts & response",
                "Monthly SLA reporting",
              ]}
            />

            <ServiceBlock
              title="Security & Compliance"
              items={[
                "Firewall & endpoint protection",
                "IAM & MFA implementation",
                "ISO, GDPR & HIPAA compliance",
                "VAPT & security audits",
              ]}
            />

            <ServiceBlock
              title="Backup & Disaster Recovery"
              items={[
                "Encrypted backups",
                "Disaster recovery planning",
                "Business continuity planning",
                "Incident response strategy",
              ]}
            />
          </div>
        </div>
      </div>
    </>
  );
}

/* ✅ Reusable Service Block */
function ServiceBlock({ title, items }) {
  return (
    <div className="col-lg-4">
      <div className="service-sidebar">
        <div className="services-list-box wow fadeInUp" data-wow-delay="0.5s">
          <h3>{title}</h3>
          <ul>
            {items.map((item, index) => (
              <li key={index}>{item}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
}
